/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

/**
 * Local Imports
*/

import { CssClassName } from '~/util/Css';

/**
 * Exports
*/

/**
 * 
 */
export function MenuItem(props) {
  /** Event Handlers **/

  /**
   * 
   */
  const handleClick = (event) => {
    props.onClick(props.name);
  };

  /** Renderers **/

  /**
   * 
   */
  const renderChild = () => {
    return props.children({
      handleClick: handleClick,
      ...props
    });
  };

  /**
   * 
   */
  const renderDefault = () => (
    <div className={ CssClassName(props.className) }>
      <a onClick={ !props.disabled ? handleClick : undefined }>
        { props.name }
      </a>
    </div>
  );

  /** Output **/

  return typeof props.children === 'function'
    ? renderChild()
    : renderDefault()
  ;
}

MenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  active: PropTypes.bool,
  disabled: PropTypes.bool
};

/**
 * 
 */
export function Menu(props) {
  /** States **/

  const [ activeItem, setActiveItem ] = useState(props.default || '');

  /** Side-Effects **/

  useEffect(() => {
    props.onChange(activeItem);
  }, [ activeItem ]);

  /** Renderers **/

  /**
   * 
   */
  const renderChildren = () => {
    return React.Children.map(
      props.children, child => (
        React.cloneElement(
          child, {
            disabled: props.disabled,
            active: child.props.name === activeItem,
            onClick: setActiveItem
          }
        )
      )
    );
  };

  /**
   * 
   */
  const renderItemsProp = () => {
    return props.items.map((name, index) => (
      <MenuItem
        key={ index }
        name={ name }
        disabled={ props.disabled }
        active={ name === activeItem }
        onClick={ setActiveItem }
      />
    ));
  };

  /** Output **/

  return (
    <nav className={ CssClassName(props.className) }>
      {
        props.children
          ? renderChildren()
          : renderItemsProp()
      }
    </nav>
  );
}

Menu.propTypes = {
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  items: PropTypes.array,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

Menu.defaultProps = {
  items: [],
  disabled: false
};